import * as React from 'react';
import { SettingsWorkspace } from '../../../models/settings-pages';
import { FieldValues, RegisterOptions, useForm } from 'react-hook-form';
import { FormOptions } from '../../../constants/form';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { Input } from '../../../components/forms/Input';
import { FormModal } from '../../../components/containers/FormModal';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import classes from './DeleteWorkspaceModal.module.scss';
import { InputTypes } from '../../../constants/form';

export type DeleteWorkspaceModalViewProps = {
  workspace?: SettingsWorkspace | null;
  onClose: () => void;
  deleteWorkspaceHandler: SubmitHandler<FieldValues>;
  submitted: boolean;
};

export const DeleteWorkspaceModalView = (props: DeleteWorkspaceModalViewProps): JSX.Element => {
  const useFormInstance = useForm(FormOptions);
  const rules: RegisterOptions = {
    required: false
  };

  const confirm = useFormInstance.watch('confirm');

  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon
      formInstance={useFormInstance}
      loading={props.submitted}
      onSubmit={props.deleteWorkspaceHandler}
      submitText={'Delete'}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={confirm !== 'DELETE' || props.submitted}
      title={'Delete Workspace?'}>
      <p>
        This will delete all Social Profiles, Posts, Analytics and everything else related to any Social Profiles within
        this Workspace. This action is not reversible.
      </p>
      <p className={classes.AlertColor}>To confirm, please type the word DELETE below:</p>
      <Input
        formInstance={useFormInstance}
        name={'confirm'}
        type={InputTypes.text}
        size={'large'}
        label={`DELETE`}
        inlinedLabel={true}
        rules={rules}
      />
    </FormModal>
  );
};
